import { RewardItem } from "../auth.types";
import img from "../assets/images/car.png";
import { motion } from "framer-motion";

interface RewardRowProps {
  item: RewardItem;
  isActive?: boolean;
}

// Child variant — consumed by parent stagger orchestration
const rowVariants: any = {
  hidden: {
    opacity: 0,
    y: 12,
    filter: "blur(4px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.35,
      ease: [0.25, 0.46, 0.45, 0.94], // easeOutQuart — smooth deceleration
    },
  },
};

const imageVariants: any = {
  hidden: { opacity: 0, scale: 0.88 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut",
      delay: 0.08, // slight image lag relative to row — adds depth
    },
  },
};

const RewardRow = ({ item, isActive = true }: RewardRowProps) => (
  <motion.div
    className={`relative flex flex-row-reverse items-center gap-4 py-1 pl-2 pr-3`}
    variants={rowVariants}
    // No need for initial/animate here — inherited from parent
    layout // smooth reorder if list changes
    whileHover={{
      backgroundColor: "rgba(217,217,217,0.06)",
      borderRadius: "8px",
      transition: { duration: 0.18, ease: "easeOut" },
    }}
    style={{ willChange: "transform, opacity" }} // GPU compositing hint
  >
    {/* Car image */}
    <motion.div
      className="flex-shrink-0 w-[106px] h-[50px] bg-[#D9D9D9]/10 rounded-md flex items-center justify-center"
      variants={imageVariants}
    >
      <img
        src={img}
        alt={item.imageAlt}
        className={`w-full h-full object-contain transition-opacity duration-200 ${
          isActive ? "opacity-100" : "opacity-50"
        }`}
      />
    </motion.div>

    {/* Info */}
    <div className="flex flex-col gap-[6px] flex-1 min-w-0 text-left">
      <motion.span
        className={`text-[0.950rem] font-bold leading-none ${
          isActive ? "text-white" : "text-white/40"
        }`}
        animate={{
          opacity: isActive ? 1 : 0.4,
          transition: { duration: 0.2 },
        }}
      >
        {item.hoursLabel}
      </motion.span>

      <motion.div
        className="bg-[#D9D9D9]/15 rounded-md pl-3"
        animate={{
          opacity: isActive ? 1 : 0.3,
          transition: { duration: 0.2 },
        }}
      >
        <span
          className={`text-[0.875rem] leading-none ${
            isActive ? "text-white/80" : "text-white/25"
          }`}
        >
          {item.rewardLabel}
        </span>
      </motion.div>
    </div>
  </motion.div>
);

export default RewardRow;
